import { getCookie } from './cookie_utils';
import cookieMessages from './cookie-banner-messages.js';
import { loadThirdPartyAndCookies, loadThirdPartyAndCookiesFirstTime,
         redirectToCookieConsent, loadThirdPartyAndCookiesOnConsent} from './cookie_loaders';

const firstTimeVisitor = getCookie('cookieconsent_status') !== 'dismiss';

if (firstTimeVisitor) {
    const onCookieConsentPage = window.location.pathname.includes("/legal/cookie-consent");
    const isEULocale = window.siteConfig['is_eu'];
    const locale = window.siteConfig['locale'];

    if (isEULocale && !onCookieConsentPage) {
        const bannerMessage = cookieMessages[locale] || cookieMessages['UK'];

        document.getElementById('cookie-consent-placeholder').innerHTML += '<div id="cookie-consent-banner"><div class="container banner-container"><div class="row"><div class="col lg-12 xl-6 center-xs start-xs"><span id="cookie-banner-message">' + bannerMessage.message + '</span></div><div class="col lg-12 xl-offset-1 center-xs start-xs"><a id="cookie-settings-button" class="btn secondary-btn teal cookie-banner-btn center-xs start-md" title="' + bannerMessage.button1 + '">' + bannerMessage.button1 + '</a><a id="cookie-accept-button" class="btn primary-btn teal cc-btn cc-dismiss cookie-banner-btn" title="' + bannerMessage.button2 + '">' + bannerMessage.button2 + '</a></div></div></div></div>';

        const learnMoreButton = document.getElementById('cookie-settings-button');
        const acceptButton = document.getElementById('cookie-accept-button');

        learnMoreButton.addEventListener('click', redirectToCookieConsent, false);
        acceptButton.addEventListener('click', loadThirdPartyAndCookiesOnConsent, false);
    } else if (!isEULocale) {
        loadThirdPartyAndCookiesFirstTime();
    } else {
        // On cookie consent page, don't load anything
    }
} else {
    loadThirdPartyAndCookies();
}
